import encryptServer from '../request/encryptRequest';

// 根据联系人电话查询个人云仓
export const getMarketStoreByLinkPhone = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/store/getMarketStoreByLinkPhone', params);

// 根据营业执照号查询云仓
export const getMarketStoreByLicenseNum = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/store/getMarketStoreByLicenseNum', params);

// 查询企业详情
export const tenantDetail = (data) => encryptServer.post('/xiaozi-xmo/wireless/saas/tenant/detail', data);

// 获取企业详情
export const getTenantDetail = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/xz/erp/enterprise/getAndSaveByKeyword', params);

// 添加云仓
export const addMarketStore = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/store/addMarketStore', params);

// 更新云仓
export const updateMarketStore = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/store/update', params);

// 分页获取商品Sku列表
export const getSkuPageList = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/pageList', params);

// 查询数量
export const getSkuCount = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/count', params);

// 查询商品Sku详情
export const goodsSkuDetail = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/detail', params);

// 查询发布商品时的sku详情
export const skuReleaseDetail = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/release/detail', params);

// 上下架商品
export const updateMarketEnable = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/update/marketEnable', params);

// 取消发布
export const cancelRelease = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/cancelRelease', params);

// 新增sku
export const goodsSkuAdd = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/add', params);

// 编辑sku
export const goodsSkuUpdate = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/update', params);

// 分页获取设备列表
export const getDevicePageList = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/device/pageList', params);

// 供需通-卖家设置-设置企业对外联系方式
export const saveServiceTel = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tenant/saveServiceTel', params);

// 供需通-卖家设置-设置询单接单人
export const saveInquirePriceTaskOrderUser = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tenant/saveInquirePriceTaskOrderUser', params);

// 保存卖家设置(包括报价设置)
export const setTenantSellerSettingDetail = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tenant/seller/setting/save', params);

// 查询卖家设置(包括报价设置、是否提示完善企业档案)
export const getTenantSellerSettingDetail = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tenant/seller/setting/detail', params);

// 保存订单确认人设置
export const saveOrderConfirmPerson = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/tenant/seller/setting/saveOrderConfirmPerson', params);

// 检查商品sku信息和sku档案信息是否存在差异，ture:有差异；false:无差异
export const checkSkuChange = (params) => encryptServer.post('/xiaozi-xms/wireless/saas/goods/sku/checkSkuChange', params);
